var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HeaderPrimaryButton } from './buttons/HeaderPrimaryButton';
import style from './AccountNotificationButton.module.scss';
import { useAperzaUserContext } from './AperzaUserContext';
import { addUtmParam } from '../utils/addUtmParam';
export function HeaderCompanyGuideButton() {
    var serviceType = useAperzaUserContext().serviceType;
    return (_jsx(HeaderPrimaryButton, __assign({ outlined: true, buttonClassName: style.notificationLoginButton, href: addUtmParam("https://www.aperza.co.jp/contact/contact-plan", 'header', serviceType) }, { children: _jsxs("span", { children: ["\u30A2\u30DA\u30EB\u30B6\u306B\u63B2\u8F09\u3092", _jsx("br", {}), "\u304A\u8003\u3048\u306E\u4F01\u696D\u306F\u3053\u3061\u3089"] }) })));
}
